import { render } from "./SettingModal.vue?vue&type=template&id=4e43dac2"
import script from "./SettingModal.vue?vue&type=script&lang=js"
export * from "./SettingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__